/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { Calculator } from './calculator';

function AdditionalDiscountValue({
    attributes, operators, formulaUpdated, setFormulaUpdated, params, fetchedFormula, setChangesMade,
}) {
    return (
        <div className="rounded-[10px] bg-[#FFFFFF] py-[22px] px-5 shadow-s16 mb-4">
            <p className="text-f3 font-normal text-[#090406] pb-5">Additional Discount (Value)</p>
            <Calculator
                attributes={attributes}
                operators={operators}
                formulaUpdated={formulaUpdated}
                setFormulaUpdated={setFormulaUpdated}
                params={params}
                fetchedFormula={fetchedFormula}
                setChangesMade={setChangesMade}
            />
        </div>
    );
}

export default AdditionalDiscountValue;
